/* eslint-disable @typescript-eslint/no-empty-function */
import { ConfirmModalParams } from './types'

export const defaultConfirmationParams = (
  t: (key: string) => string
): ConfirmModalParams => {
  return {
    title: t('confirm-action'),
    description: t('confirm-description'),
    closeText: t('confirm-cancel'),
    confirmText: t('confirm-text'),
    onClose: () => {},
    onConfirm: () => {}
  }
}
